import React from 'react';
import { useTranslation } from 'react-i18next';
import companyLogo from '../assets/img/banner/logo.png';
import entryLogo from '../assets/img/entry-logo.png';

function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-gray-800 text-gray-300 py-12 dark:bg-gray-900">
      <div className="container mx-auto px-4">
        <div className="flex flex-col lg:flex-row justify-between items-start gap-10 lg:gap-8">

          {/* 左側：公司 Logo 和聯絡資訊 */}
          <div className="w-full lg:w-1/3 flex flex-col items-center lg:items-start text-center lg:text-left mb-8 lg:mb-0">
            <div className="flex items-center space-x-3 mb-4">
              <img src={entryLogo} alt="Wintriss Engineering Logo" className="h-10 w-auto" />
              <img src={companyLogo} alt="Wintriss Logo" className="h-10 w-auto" />
            </div>
            <p className="text-sm mb-2 text-white">{t('footer.address')}</p> {/* 台北市北投區承德路七段401巷1003號 */}
            <p className="text-white mb-2">sales@iwscan.com</p>
            <p className="text-sm text-white">{t('footer.phone')}</p> {/* 02-28925000 */}
          </div>

          {/* 中間區塊：產品、解決方案、公司連結 */}
          <div className="w-full lg:w-2/3 grid grid-cols-2 sm:grid-cols-3 gap-8 lg:gap-4 text-center lg:text-left">
            {/* 產品 */}
            <div>
              <h4 className="font-bold text-white mb-4 text-lg border-b-2 border-blue-500 pb-2 inline-block">
                {t('footer.products.title')} {/* 產品 */}
              </h4>
              <ul className="space-y-2">
                {/* 隱藏：表面檢測系統（原 rollMaterialInspection，現 surfaceInspectionSystem） */}
                {/* <li><a href="/products/inspection" className="text-sm hover:text-blue-400 transition-colors">{t('footer.products.surfaceInspectionSystem')}</a></li> */}
                <li><a href="/products/camera" className="text-sm hover:text-blue-400 transition-colors">{t('footer.products.industrialCamera')}</a></li> {/* 工業相機 */}
                <li><a href="/products/lighting" className="text-sm hover:text-blue-400 transition-colors">{t('footer.products.lighting')}</a></li> {/* 光源 */}
                <li><a href="/products/software" className="text-sm hover:text-blue-400 transition-colors">{t('footer.products.software')}</a></li> {/* 軟體 */}
                <li><a href="/products/solutions" className="text-sm hover:text-blue-400 transition-colors">{t('footer.products.labeler')}</a></li> {/* 標籤機 */}
              </ul>
            </div>

            {/* 解決方案 */}
            <div>
              <h4 className="font-bold text-white mb-4 text-lg border-b-2 border-blue-500 pb-2 inline-block">
                {t('footer.solutions.title')} {/* 解決方案 */}
              </h4>
              <ul className="space-y-2">
                <li><a href="/solutions/film" className="text-sm hover:text-blue-400 transition-colors">{t('footer.solutions.film')}</a></li> {/* 塑膠薄膜 */}
                <li><a href="/solutions/battery" className="text-sm hover:text-blue-400 transition-colors">{t('footer.solutions.battery')}</a></li> {/* 鋰電池 */}
                <li><a href="/solutions/pcb" className="text-sm hover:text-blue-400 transition-colors">{t('footer.solutions.pcb')}</a></li> {/* 電子材料 */}
                <li><a href="/solutions/nonwoven" className="text-sm hover:text-blue-400 transition-colors">{t('footer.solutions.nonwoven')}</a></li> {/* 不織布 */}
                <li><a href="/solutions/metal" className="text-sm hover:text-blue-400 transition-colors">{t('footer.solutions.metal')}</a></li> {/* 金屬箔 */}
                <li><a href="/solutions/paper" className="text-sm hover:text-blue-400 transition-colors">{t('footer.solutions.paper')}</a></li> {/* 紙 */}
                <li><a href="/solutions/solar" className="text-sm hover:text-blue-400 transition-colors">{t('footer.solutions.solar')}</a></li> {/* 太陽能 */}
                <li><a href="/solutions/glass" className="text-sm hover:text-blue-400 transition-colors">{t('footer.solutions.glass')}</a></li> {/* 玻璃 */}
              </ul>
            </div>

            {/* 公司 */}
            <div>
              <h4 className="font-bold text-white mb-4 text-lg border-b-2 border-blue-500 pb-2 inline-block">
                {t('footer.company.title')} {/* 公司 */}
              </h4>
              <ul className="space-y-2">
                <li><a href="/about-us" className="text-sm hover:text-blue-400 transition-colors">{t('footer.company.about')}</a></li> {/* 關於 */}
                <li><a href="/contact" className="text-sm hover:text-blue-400 transition-colors">{t('footer.company.contact')}</a></li> {/* 聯絡 */}
              </ul>
            </div>
          </div>
        </div>

        {/* 版權資訊 */}
        <div className="border-t border-gray-700 mt-10 pt-8 text-center text-sm text-gray-400 ">
          <p className="text-white">&copy; 2025 微覺視 . {t('footer.copyright')}</p> {/* 版權所有，保留所有權利 */}
        </div>
      </div>
    </footer>
  );
}

export default Footer;